import { Api, ApiMethod } from "../components/common/ApiLinkedButton";
import { rawContentApiLinkConstants } from "../constants";
import { PageResponse } from "../paging/Paging.Model";
import { RawContent, RawContentRequest } from "./RawContent.Model";

export const RawContentAPI = {
  fetchAllRawContent: function (
    page: number,
    size: number,
    status?: string
  ): Promise<PageResponse<RawContent>> {
    let url = `${rawContentApiLinkConstants.API_RAW_CONTENT_ALL}?page=${page}&size=${size}`;
    if (status) {
      url += `&status=${status}`;
    }
    return new Api<void, PageResponse<RawContent>>(
      url,
      ApiMethod.GET
    ).executeV2();
  },

  createRawContent: function (request: RawContentRequest): Promise<RawContent> {
    return new Api<RawContentRequest, RawContent>(
      rawContentApiLinkConstants.API_RAW_CONTENT_CREATE,
      ApiMethod.POST
    ).executeV2(request);
  },

  updateRawContent: function (
    id: number,
    request: RawContentRequest
  ): Promise<RawContent> {
    return new Api<RawContentRequest, RawContent>(
      rawContentApiLinkConstants.API_RAW_CONTENT_UPDATE.replace(
        "{id}",
        id.toString()
      ),
      ApiMethod.PUT
    ).executeV2(request);
  },

  deleteRawContent: function (id: number): Promise<void> {
    return new Api<void, void>(
      rawContentApiLinkConstants.API_RAW_CONTENT_DELETE.replace(
        "{id}",
        id.toString()
      ),
      ApiMethod.DELETE
    ).executeV2();
  },

  processNextRawContent: function (): Promise<void> {
    return new Api<void, void>(
      rawContentApiLinkConstants.API_RAW_CONTENT_PROCESS_NEXT,
      ApiMethod.POST
    ).executeV2();
  },

  requeueRawContent: function (id: number): Promise<RawContent> {
    return new Api<void, RawContent>(
      rawContentApiLinkConstants.API_RAW_CONTENT_REQUEUE.replace(
        "{id}",
        id.toString()
      ),
      ApiMethod.POST
    ).executeV2();
  },
};
